module.exports = __webpack_public_path__ + "media/ALARM_CLOCK.a1a4a003.mp3";